import React, { useState, useEffect, useContext } from "react";
import { Spinner, Modal, ModalBody } from "react-bootstrap";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import '../assets/css/Modal.css';
import { LanguageContext } from "../contexts/LanguageContext";

const RemoveAccountModal = ({ accountName, vaultId, accountType, setRemoveModal, sendDataToParent }) => {
    
    const handleCancel = () => setRemoveModal(false);    
    const [isLoading, setLoading] = useState(false);
    const Payload = GetPayLoad('PayLoad');

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region"   : Payload?.region
    };    
        
	const [isDisabled, setDisabled] = useState(false);
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }
        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);

    const handleRemove = (e) => {
        setDisabled(true);
        setLoading(true);
        e.preventDefault();

        const targetActivateAccountUrl = process.env.REACT_APP_API_ACTIVATE_ACCOUNT_ENDPOINT;
        getApiService(baseUrl, targetActivateAccountUrl, { cim: Payload?.cim, vault_id: vaultId, account_type: accountType, action: 'remove' }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setDisabled(false);
                    sendDataToParent(genericContent?.service_post_error, 'error');
                }else{
                    const result = response.data.data;
                    if(result){
                        setRemoveModal(false);
                        sendDataToParent(overViewContent?.overview_remove_accounts_success_msg, 'success');
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                setDisabled(false);
                sendDataToParent(overViewContent?.service_post_error, 'error');
            });
    }

    return (
        
        <div>			
            <Modal.Header className={`billing-header d-xl-flex d-md-flex pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                <div></div>
            </Modal.Header>
            <ModalBody className="removeaccount">                
                <div>
                    <div tabIndex={0} aria-atomic="true" style={{fontSize: '13px'}}>
                        <p className="lh-base">
                        {overViewContent?.overview_remove_account_confirmation_msg} <span className="fw-semibold"> {accountName}</span> {overViewContent?.overview_remove_account_confirmation_msg1}
                        </p>

                        <p className="lh-base">
                            {overViewContent?.overview_remove_account_confirmation_msg_notice}
                        </p>
                        {/* <p className="lh-base">
                            There are pending payment(s). If this account is the source, any payments associated with this account will be cancelled.
                        </p> */}
                    </div>
                </div>
                {/* Q5-specific responsive button order: mobile/tablet (Delete top, Cancel bottom), large screens (Cancel first, Delete second) */}
                {Payload?.owning_carrier === 'Q5' ? (
                    <div className="col-12" style={{fontSize: '13px'}}>
                        {/* Mobile/Tablet: Delete (primary) on top, Cancel at bottom */}
                        <div className="d-block d-lg-none">
                            <input type="submit" aria-label="submit" className="me-3 btn btn-secondary btn-lg mt-4 col-5 removedeletebtn"
                                onClick={handleRemove} value={overViewContent?.overview_remove_accounts_delete_text} required="" disabled={isDisabled} />
                                {isLoading && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '15px' }}>
                                <Spinner animation="border" role="status" ></Spinner>
                                <div style={{fontSize: "12px"}}>{genericContent?.loading_message}</div>
                            </div>
                        )}
                            <input type="button" aria-label="Canel"
                                className="btn btn-outline-secondary btn-lg mt-4 col-5 removecancelbtn" value={overViewContent?.overview_remove_accounts_cancel_text}
                                data-bs-toggle="modal" href="#exampleModalFullscreen" onClick={handleCancel} />
                        </div>
                        {/* Large screens: Cancel first, Delete second */}
                        <div className="d-none d-lg-flex justify-content-center">
                            <input type="button" aria-label="Canel"
                                className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 removecancelbtn" value={overViewContent?.overview_remove_accounts_cancel_text}
                                data-bs-toggle="modal" href="#exampleModalFullscreen" onClick={handleCancel} />
                            <input type="submit" aria-label="submit" className="btn btn-secondary btn-lg mt-4 col-5 removedeletebtn"
                                onClick={handleRemove} value={overViewContent?.overview_remove_accounts_delete_text} required="" disabled={isDisabled} />
                        </div>
                        {isLoading && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '15px' }}>
                                <Spinner animation="border" role="status" ></Spinner>
                                <div style={{fontSize: "12px"}}>{genericContent?.loading_message}</div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="col-12" style={{fontSize: '13px'}}>
                        <input type="button" aria-label="Cancel"
                            className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 removecancelbtn" value={overViewContent?.overview_remove_accounts_cancel_text}
                            data-bs-toggle="modal" href="#exampleModalFullscreen" onClick={handleCancel} />
                        <input type="submit" aria-label="submit" className="btn btn-secondary btn-lg mt-4 col-5 removedeletebtn"
                            onClick={handleRemove} value={overViewContent?.overview_remove_accounts_delete_text} required="" disabled={isDisabled} />
                        {isLoading && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '15px' }}>
                                <Spinner animation="border" role="status" ></Spinner>
                                <div style={{fontSize: "12px"}}>{genericContent?.loading_message}</div>
                            </div>
                        )}
                    </div>
                )}
			</ModalBody>
        </div>
    )
}

export default RemoveAccountModal;